var $ = require('jquery');
module.exports = {
    on:function (name,cb) {
        $(document).on(name,function (e,data){
            cb(data);
        });
    },
    emit:function (name,data) {
        $(document).trigger(name,data);
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/service/event.js
 ** module id = 21
 ** module chunks = 0
 **/